import Profile from '../../../models/profile';

export default class GetProfileResponse {
  profile: Profile;

  constructor(json: any) {
    this.profile = new Profile(json);
  }
}
